// 騎士の切り下がり (lanceCross) の槍の軌跡 — 見本の絵から再現する (2026-09-30)。
//   ユーザー (09-30b P-6): 剣圧の三日月は「大げさ」→「三日月が良くないのかも知れない。他のゲーム参考にしてほしい」
//   → 他ゲームの調べ (隻狼の一心の跳び退き払いの軌跡・ホロウナイトの斬撃・Hades の槍兵は絵を当たりに合わせた) から
//   「A 振りの軌跡を伸ばす」を選んだ。届く範囲を別の形で足さず、槍先が通った跡に槍の高さの平たい薄い帯を
//   当たりの前端 (当時 200px・10-01 から穂先の 105px) まで残し、0.12 秒ほどで消す。台帳 bosses.md「磨きの見定めパック 09-30b の回答」。
//   見本 = そざい/fx/knight-spear-trail/sheet_raw.png (3コマ・Codex 票 knight-suri-art-0930)。
//   材料 = public/sprites/fx/knight-spear-trail/ trail_full.png (2コマ目＝振り切った瞬間) / trail_fade.png (3コマ目＝消えかけ)。
//     白・透明度＝明るさ。帯の前端 (いちばん明るく太い所) が右。
//   動き: 振りの間は前端が体の後ろから当たりの前端まで走り、帯は前端の後ろにだけ見える (短い帯→長い帯＝見本の1→2コマ)。
//   振り切った後は尾から先にほどけ (上下にまだら)、3コマ目の形へ移りながら消える。色は冷たい銀。
// ブラウザ専用 (Image が無い Vitest では描かない。位置の計算 knightSpearTrailSpan はテストできる)。

// 2026-10-01 既定 = 'sweep': 切り下がりが「詰めて→払って→跳び下がる」になり、払いは薙ぎと同じ絵なので、光も薙ぎの弧
//   (render.ts SMEAR_ARTS.lanceSweep_contact) がそのまま出る = このファイルの帯は描かない。
//   DEV `?knightLeapFx=trail` = この帯 (10-01 の弧 C)・`crescent` = 09-30 の槍の弧＋剣圧の三日月。どちらも跳びながら払っていた頃の見た目。
// 2026-10-01 夜 既定 = 'trail' に戻す: 前に出ずその場で払って跳ぶ形になり、薙ぎの弧 (上から後ろへ振りかぶった大きな弧) は
//   ユーザー「薙ぎのエフェクトが縦に振ってるエフェクトになってる」→ 選択「腰の高さで横に流れる帯」= この帯。
//   'sweep' (薙ぎの弧) は DEV `?knightLeapFx=sweep` で見比べられる。
// 2026-10-02 既定 = 'arc': 帯は「ほぼ見えなくなった。矛先が光ってるのは見えるけどそうじゃない」→ 見本4案から
//   ユーザー選択「A 手前を回る浅い弧」(src/knight_cross_arc.ts)。この帯は DEV `?knightLeapFx=trail` で見比べられる。
export type KnightLeapFx = 'arc' | 'sweep' | 'trail' | 'crescent'
let leapFx: KnightLeapFx = 'arc'
export function getKnightLeapFx(): KnightLeapFx { return leapFx }
export function setKnightLeapFx(v: string): void { leapFx = v === 'crescent' || v === 'sweep' || v === 'trail' ? v : 'arc' }

// 弧 (2026-10-01・票 knight-fx-motion-1001・DEV の比較だけ・配布版は a のまま)。
//   ユーザー (09-30c T-1)「もう少しだけ弧を」→ 見本 そざい/fx/knight-fx-look-1001/compare_trail.png (A 今と同じ / B 少し弧 / C はっきり弧)
//   → 10-01「動きを見ないとわからないけどいったんりょうほうBかな？」。
//   帯の形は世界に固定した道筋: 前端 (当たりの前端) は今と同じ槍の高さ、尾 (体の後ろ) へ向かってなめらかに持ち上がる
//   (上から後ろへ振りかぶった槍が前へ払われた跡)。前端が走る間は、前端もその道筋の上 (少し高い所) から降りてくる。
//   持ち上がりの量 = 見本の2コマ目の実測 (尾の端の高さ ÷ 帯の横の長さ): B 0.087 / C 0.135 (notes.md「Measured curvature」)。
//   曲がり方 = 前端で水平・尾へ向かって2乗で持ち上がる (大きな円のごく一部の近似)。材料は縦の細い短冊に分けてずらして描く。
// 検収 10-01d (ユーザー T-1「C はっきり弧」・メモ「出るタイミングが若干ずれてる？後位置かな？前に光線が出てるように見えちゃう」)
//   → C を既定 (配布版) にした。`?knightTrail=a|b` (DEV) で前の帯と見比べられる。
//   実測した原因: 帯の尾が跳び始めの位置に固定され、騎士は 90ms で約 54px 後ろへ跳ぶ → 帯が騎士の体から離れ、
//   穂先の前だけに残った (見本は帯が騎士の体を通って後ろで持ち上がる)。さらに前端が 90ms かけて前へ走るので、
//   振り切った絵が出てから光が前へ飛んでいくように見えた。
//   1回目の直し (d4ae4c57): 尾を跳び下がる体に付けた・前端の走りを 90→50ms → ユーザー「どうしても前にエフェクトが出ていってるように見える」。
//   根本 = 当たり (跳び始めから 200px) が振った瞬間の穂先 (約 105px) より約 100px 先まで届き、光がその差を見せていた。
//   → ユーザー選択「当たりを穂先に合わせる」: 当たりを 105px へ (src/attacks.ts)、光は穂先が通った所だけ。
//   今の形: 帯は騎士の体と一緒に動く (世界に置き去りにしない＝跳び下がる穂先より前に光が残らない)。
//   尾 = 体の後ろ KNIGHT_TRAIL_BEHIND_PX、前端 = 今の穂先。振りの間に前端が尾から穂先まで走り、穂先で止まって消える。
//   帯が短くなった (240 → 175px) ので、持ち上がりの比は尾の高さが前と同じくらい (約 35px) になるよう上げた (c 0.135 → 0.2)。
export type KnightTrailArc = 'a' | 'b' | 'c'
export const KNIGHT_TRAIL_ARC_RISE: Record<KnightTrailArc, number> = { a: 0, b: 0.13, c: 0.2 }
let trailArc: KnightTrailArc = 'c'
export function getKnightTrailArc(): KnightTrailArc { return trailArc }
export function setKnightTrailArc(v: string | null): void { trailArc = v === 'a' || v === 'b' ? v : 'c' }
/** 道筋の持ち上がり (世界の px・上が +)。end = 当たりの前端の x、L = 帯の長さ。a は常に 0。 */
export function knightTrailArcLift(worldX: number, end: number, dir: number, L: number, rise = KNIGHT_TRAIL_ARC_RISE[trailArc]): number {
  if (rise <= 0 || L <= 0) return 0
  const u = Math.max(0, Math.min(1, ((end - worldX) * dir) / L))   // 0 = 前端 (穂先)・1 = 尾
  return rise * L * u * u
}
/** 短冊の幅 (材料の px)。材料は約 0.38 倍で描くので画面で約 1.5px。 */
const ARC_SLICE_SRC_PX = 4

const BASE = '/sprites/fx/knight-spear-trail/'
/** 材料の前端 (px)。trail_full は x=665・y=41.6、trail_fade は x=650・y=45.1 (明るさ>120 の最も右の列)。 */
const FULL_HEAD = { x: 665, y: 41.6 }
const FADE_HEAD = { x: 650, y: 45.1 }
/** 材料の尾 (見える所の左端)。 */
const FULL_TAIL_X = 35
/** 体の後ろ、帯の尾が始まる所 (跳び始めの位置から後ろへ)。 */
export const KNIGHT_TRAIL_BEHIND_PX = 70
export const KNIGHT_TRAIL_SWEEP_MS = 50
export const KNIGHT_TRAIL_FADE_MS = 130
const TINT = [206, 222, 246] as const
const ERODE_LEVELS = [0, 0.3, 0.55, 0.85]

let started = false
let full: HTMLCanvasElement[] | null = null
let fade: HTMLCanvasElement | null = null

const hash01 = (n: number): number => { const s = Math.sin(n * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s) }
function noise2(x: number, y: number, seed: number, cell: number): number {
  const cx = Math.floor(x / cell), cy = Math.floor(y / cell)
  const fx = x / cell - cx, fy = y / cell - cy
  const sx = fx * fx * (3 - 2 * fx), sy = fy * fy * (3 - 2 * fy)
  const v = (i: number, j: number) => hash01((cx + i) * 57.3 + (cy + j) * 91.1 + seed * 13.7)
  const a = v(0, 0) + (v(1, 0) - v(0, 0)) * sx
  const b = v(0, 1) + (v(1, 1) - v(0, 1)) * sx
  return a + (b - a) * sy
}

/** 染めて、必要なら尾からほどけさせる。筋目に沿って消えるよう、ノイズは横に長く縦に細かい。 */
function bake(img: HTMLImageElement, erode: number, headX: number): HTMLCanvasElement {
  const c = document.createElement('canvas')
  c.width = img.width; c.height = img.height
  const g = c.getContext('2d')!
  g.drawImage(img, 0, 0)
  const d = g.getImageData(0, 0, c.width, c.height)
  const p = d.data
  for (let y = 0; y < c.height; y++) {
    for (let x = 0; x < c.width; x++) {
      const i = (y * c.width + x) * 4
      let a = p[i + 3] / 255
      if (a <= 0) continue
      if (erode > 0) {
        const tail01 = Math.max(0, Math.min(1, (headX - x) / (headX - FULL_TAIL_X)))   // 0 = 前端・1 = 尾
        const n = 0.6 * noise2(x * 0.25, y * 3, 3, 9) + 0.4 * noise2(x * 0.6, y * 6, 7, 7)
        // 10-01d: 尾が騎士の体まで伸びたので、尾から先に消えると前だけ残って「前に光線」に戻る → 尾の偏りを弱めた (0.25+1.6 → 0.55+0.9)。
        const thr = erode * (0.35 + 0.9 * n) * (0.55 + 0.9 * tail01)
        a *= Math.max(0, Math.min(1, (a - thr + 0.25) / 0.5))
      }
      p[i] = TINT[0]; p[i + 1] = TINT[1]; p[i + 2] = TINT[2]
      p[i + 3] = Math.round(a * 255)
    }
  }
  g.putImageData(d, 0, 0)
  return c
}

function load(name: string, done: (img: HTMLImageElement) => void): void {
  const img = new Image()
  img.onload = () => done(img)
  img.src = `${BASE}${name}`
}

/** 材料の読み込み開始 (render.ts から最初の描画で呼ぶ・main.ts の preload でも呼んでよい)。 */
export function preloadKnightSpearTrail(): void {
  if (started || typeof Image === 'undefined' || typeof document === 'undefined') return
  started = true
  load('trail_full.png', (img) => { full = ERODE_LEVELS.map((e) => bake(img, e, FULL_HEAD.x)) })
  load('trail_fade.png', (img) => { fade = bake(img, 0.2, FADE_HEAD.x) })
}

/**
 * 帯の見える範囲 (世界の x)。dir = 前の向き、reach = 穂先 (= 当たりの前端 lanceCross 105px)。
 * bodyX = 今の騎士の位置 (跳び下がりで後ろへ動く)。帯は丸ごと体と一緒に動く。省くと跳び始めの位置 anchorX。
 * head = 前端 (振りの間に尾から穂先まで走る・穂先より前へは出ない)・tail = 尾。振りの前 (ageMs<0) は null。
 */
export function knightSpearTrailSpan(anchorX: number, dir: number, reach: number, ageMs: number, bodyX = anchorX): { head: number; tail: number; end: number; sweep: number } | null {
  if (ageMs < 0 || ageMs > KNIGHT_TRAIL_SWEEP_MS + KNIGHT_TRAIL_FADE_MS) return null
  const sweep = Math.min(1, ageMs / KNIGHT_TRAIL_SWEEP_MS)
  const p = 1 - (1 - sweep) * (1 - sweep) * (1 - sweep)   // 出だしが速く、前端で減速して止まる (最後の当たりの端を見せる)
  const tail = bodyX - dir * KNIGHT_TRAIL_BEHIND_PX
  const end = bodyX + dir * reach
  return { head: tail + (end - tail) * p, tail, end, sweep }
}

/** 描く。材料が未読み込みなら false (呼び出し側は何も描かない)。y = 槍の高さ。 */
export function drawKnightSpearTrail(ctx: CanvasRenderingContext2D, anchorX: number, y: number, dir: number, reach: number, ageMs: number, bodyX = anchorX): boolean {
  preloadKnightSpearTrail()
  if (!full || !fade) return false
  const span = knightSpearTrailSpan(anchorX, dir, reach, ageMs, bodyX)
  if (!span) return true
  const L = reach + KNIGHT_TRAIL_BEHIND_PX
  const s = L / (FULL_HEAD.x - FULL_TAIL_X)
  const t = Math.max(0, (ageMs - KNIGHT_TRAIL_SWEEP_MS) / KNIGHT_TRAIL_FADE_MS)   // 0..1 = 振り切った後の消え
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  // 見える範囲 = 尾から前端まで (前端の少し先までは材料の縁の柔らかさを残す)。
  const x0 = Math.min(span.tail, span.head + dir * 6), x1 = Math.max(span.tail, span.head + dir * 6)
  ctx.beginPath()
  const maxLift = KNIGHT_TRAIL_ARC_RISE[trailArc] * L
  ctx.rect(x0, y - 60 - maxLift, x1 - x0, 120 + maxLift)
  ctx.clip()
  const rise = KNIGHT_TRAIL_ARC_RISE[trailArc]
  const end = span.end
  const draw = (img: HTMLCanvasElement, head: { x: number; y: number }, alpha: number, sy: number) => {
    if (alpha <= 0.003) return
    ctx.globalAlpha = alpha
    ctx.save()
    ctx.translate(span.head, y)
    ctx.scale(dir * s, s * sy)
    if (rise <= 0) {
      ctx.drawImage(img, -head.x, -head.y)
    } else {
      // 弧: 材料を縦の短冊に分け、短冊ごとに道筋の高さへずらす (穂先からの距離で決まる = 前端が走っても形は動かない)。
      for (let sx0 = 0; sx0 < img.width; sx0 += ARC_SLICE_SRC_PX) {
        const w = Math.min(ARC_SLICE_SRC_PX, img.width - sx0)
        const wx = span.head + dir * s * (sx0 + w / 2 - head.x)
        const lift = knightTrailArcLift(wx, end, dir, L, rise)
        ctx.drawImage(img, sx0, 0, w, img.height, sx0 - head.x, -head.y - lift / (s * sy), w, img.height)
      }
    }
    ctx.restore()
  }
  if (t <= 0) {
    // 振りの間: 帯が前端と一緒に走る。出だしは少し薄く (見本1コマ目の短く淡い帯)。
    draw(full[0]!, FULL_HEAD, 0.75 + 0.25 * span.sweep, 1)
  } else {
    // 消え: 尾からほどける段を重ねてつなぎ、後半は3コマ目の形 (尾が途切れた細い筋) へ移る。細く、薄く。
    const e = Math.min(ERODE_LEVELS.length - 1, t * (ERODE_LEVELS.length - 1) * 1.15)
    const lo = Math.floor(e), hi = Math.min(ERODE_LEVELS.length - 1, lo + 1), w = e - lo
    const out = (1 - t) * (1 - t)
    const sy = 1 - 0.35 * t
    const mix = Math.min(1, t * 1.6)
    draw(full[lo]!, FULL_HEAD, out * (1 - w) * (1 - mix * 0.6), sy)
    if (hi !== lo) draw(full[hi]!, FULL_HEAD, out * w * (1 - mix * 0.6), sy)
    draw(fade, FADE_HEAD, out * mix * 0.8, sy)
  }
  ctx.restore()
  ctx.globalAlpha = 1
  return true
}

// URL の読み取りは最後 (上の let が初期化された後)。配布版はこの箱ごと消える = 常に c (はっきり弧・10-01d)。
if (import.meta.env.DEV && typeof window !== 'undefined') {
  setKnightTrailArc(new URLSearchParams(window.location.search).get('knightTrail'))
}
